export let placesSkipToMainContent = "yZ6gOb";
export let placesMainContent = "stoxAd";
export default {placesSkipToMainContent,placesMainContent};